import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const BarcodeScannerItemDefaultProps = {
  ...ClassNameDefaultProps,
  brand: {},
  customerPrice: null,
  discountPrice: null,
  ebatExists: false,
  image: null,
  manufacturerSku: '',
  name: '',
  id: null,
  invoiceUnit: null,
  isVisible: false,
  salesPackaging: null,
  splitPackaging: false,
  saleUnit: '',
  sku: '',
  onSuccess: () => {},
};

export const BarcodeScannerItemPropTypes = {
  ...ClassNamePropTypes,
  brand: PropTypes.shape({}),
  customerPrice: PropTypes.number,
  discountPrice: PropTypes.number,
  ebatExists: PropTypes.bool,
  image: PropTypes.shape({
    alt: PropTypes.string,
    url: PropTypes.string,
  }),
  manufacturerSku: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  invoiceUnit: PropTypes.string,
  isVisible: PropTypes.bool,
  salesPackaging: PropTypes.number,
  splitPackaging: PropTypes.bool,
  saleUnit: PropTypes.string,
  sku: PropTypes.string,
  onSuccess: PropTypes.func,
};
